export const USERS_TYPES = Object.freeze({
  GET_USERS_IS_LOADING: '@react-mvp/GET_USERS_IS_LOADING',
  GET_USERS_SUCCESSFUL: '@react-mvp/GET_USERS_SUCCESSFUL',
  GET_USERS_FAILED: '@react-mvp/GET_USERS_FAILED',
  GET_USERS_RESET: '@react-mvp/GET_USERS_RESET',
});
